import axios from "axios";

const cdeDefinitionsExploreURL = `/api/v1/cde_definitions_explore`;

const cdeDefinitionsExploreApi = {
  fetchDomains: (id, page = 1, per = 1000, search = "") =>
    axios.get(
      `${cdeDefinitionsExploreURL}/${id}/domains?page=${page}&per_page=${per}&search=${search}`
    ),
  fetchDataSources: (id, page = 1, per = 1000, search = "") =>
    axios.get(
      `${cdeDefinitionsExploreURL}/${id}/data_sources?page=${page}&per_page=${per}&search=${search}`
    ),
  fetchBusinessTerms: (id, page = 1, per = 1000, search = "") =>
    axios.get(
      `${cdeDefinitionsExploreURL}/${id}/business_terms?page=${page}&per_page=${per}&search=${search}`
    ),
  associateBusinessTerms: (id, payload) =>
    axios.post(`${cdeDefinitionsExploreURL}/${id}/business_terms/associate`, {
      business_term: payload,
    }),
  fetchReferenceSources: (id, page = 1, per = 1000, search = "") =>
    axios.get(
      `${cdeDefinitionsExploreURL}/${id}/reference_sources?page=${page}&per_page=${per}&search=${search}`
    ),
  associateReferenceSources: (id, payload) =>
    axios.post(
      `${cdeDefinitionsExploreURL}/${id}/reference_sources/associate`,
      {
        reference_source: payload,
      }
    ),
  associateDomains: (id, payload) =>
    axios.post(`${cdeDefinitionsExploreURL}/${id}/domains/associate`, {
      domain: payload,
    }),
  associateDataSources: (id, payload) =>
    axios.post(`${cdeDefinitionsExploreURL}/${id}/data_sources/associate`, {
      data_source: payload,
    }),
  fetchCdeRules: (id, page = 1, per = 1000, search = "") =>
    axios.get(`${cdeDefinitionsExploreURL}/${id}/cde_rules`, {
      params: { page, per, search },
    }),
  createCdeRule: (id, payload) =>
    axios.post(`${cdeDefinitionsExploreURL}/${id}/cde_rules`, {
      cde_rule: payload,
    }),
  showCdeRule: (id, rule_id) =>
    axios.get(`${cdeDefinitionsExploreURL}/${id}/cde_rules/${rule_id}`),
  updateCdeRule: (id, rule_id, payload) =>
    axios.put(`${cdeDefinitionsExploreURL}/${id}/cde_rules/${rule_id}`, {
      cde_rule: payload,
    }),
  deleteCdeRules: (id, rule_ids) => {
    const params = new URLSearchParams(
      rule_ids.map(rule_id => ["ids[]", rule_id])
    );
    return axios.delete(
      `${cdeDefinitionsExploreURL}/${id}/cde_rules/1?${params.toString()}`
    );
  },
};

export default cdeDefinitionsExploreApi;
